module.exports = __webpack_public_path__ + "img/automated_student_progress_tracking.7674a38b.svg";